import { render, staticRenderFns } from "./MiniPlantCard.vue?vue&type=template&id=8dc5ad14&scoped=true"
import script from "./MiniPlantCard.vue?vue&type=script&lang=ts"
export * from "./MiniPlantCard.vue?vue&type=script&lang=ts"
import style0 from "./MiniPlantCard.vue?vue&type=style&index=0&id=8dc5ad14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc5ad14",
  null
  
)

export default component.exports